<template>
  <v-layout row>
    <v-flex xs12>
      <v-card class="elevation-11">
        <v-toolbar color="blue-grey lighten-5">
          <v-toolbar-title class="ttl">{{pageTitle}}</v-toolbar-title>
          <span class="ml-2 tracks">(Click link to view exercises)</span>
        </v-toolbar>

      <v-list one-line>
          <template v-for="(item, index) in topics">
            <v-list-tile
              class="mt-1"
              ripple
              :key="index"
            >
              <v-list-tile-content>
                <v-list-tile-sub-title class="text--primary dl">
                  <a @click="setExercise(item.topic)"  class="mr-3" target="_blank"><span class="dlTitle">{{item}}</span></a>
                </v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-divider v-if="index + 1 < topics.length" :key="index"></v-divider>
          </template>
        </v-list>

      <!-- <v-list v-else one-line>
          <template v-for="(exercise, index) in exercises">
            <v-list-tile
              class="mt-1"
              ripple
              :key="index"
            >
              <v-list-tile-content>
                <v-list-tile-sub-title class="text--primary dl">
                  <a :href=exercise.downloadURL class="mr-3" target="_blank"><span class="dlTitle">{{exercise.title}}</span></a>
                </v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-divider v-if="index + 1 < exercises.length" :key="index"></v-divider>
          </template>
        </v-list> -->

      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapState } from "vuex"
export default {
  mounted() {
      let arrTE = this.$store.getters.getTargetedExercises
      var result = Object.keys(obj).map(function(key) {
        return [Number(key), obj[key]];
      });
      console.log('hello');
  },
  data() {
    return {
      pageTitle: 'Targeted Exercises',
      topic: ''
    }
  },
  computed: {
    topics() {
      return this.$store.getters.getTargetedExercises
    },
    exerciseType() {
      return this.$store.state.exerciseType
    },
    exercises() {
      return this.$store.state.loadedExercises
    }
  },
  methods: {
    setExercise(id) {
      alert('hello')
      // this.$store.dispatch("setExercise", strTopic)
      // this.pageTitle = strTopic
    },
    getExercises() {
      this.$store.dispatch("getExercises")
    }
  }
}
</script>

<style scoped>

a {
  color: #3d3d3d;
  font-size: 12px;
  margin-left: 5px;
}

.dlTitle {
    font-size: .95rem;
    white-space: -moz-pre-wrap !important;  /* Mozilla, since 1999 */
    white-space: -pre-wrap;      /* Opera 4-6 */
    white-space: -o-pre-wrap;    /* Opera 7 */
    white-space: pre-wrap;       /* css-3 */
    word-wrap: break-word;       /* Internet Explorer 5.5+ */
    white-space: -webkit-pre-wrap; /* Newer versions of Chrome/Safari*/
    word-break: break-all;
    white-space: normal;
}

.tracks {
  font-size: 13px;
}

.ttl {
  display: flex;
  flex-direction: column;
  font-size: 1.2rem;
  font-weight: bold;
}

.dl {
  font-family: "Lato", sans-serif;
  font-weight: 400;
}

hr {
margin: 10px;
}
</style>